var map = {
	"./components/account/config/account.settings.js": "./src/components/account/config/account.settings.js",
	"./components/invoice/config/invoice.settings.js": "./src/components/invoice/config/invoice.settings.js",
	"./components/phone/config/phone.settings.js": "./src/components/phone/config/phone.settings.js",
	"./components/program/config/program.settings.js": "./src/components/program/config/program.settings.js",
	"./components/screen/config/screen.settings.js": "./src/components/screen/config/screen.settings.js",
	"./config/app.settings.js": "./src/config/app.settings.js",
	"./config/files.settings.js": "./src/config/files.settings.js",
	"./config/icons.settings.js": "./src/config/icons.settings.js",
	"./config/prototype.settings.js": "./src/config/prototype.settings.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive \\.settings\\.js$";